import { Form } from './form';
import { Config } from '../config';
import { FormTypes } from './form-types';
import { Order } from '../config/order';
import { PaymentType } from '../providers/payment-type';
import { StripeMobilePayView } from '../view/stripe-mobile-pay-view';
import { StripeProvider } from '../providers/stripe-provider';
import { ErrorView } from '../view/error-view';
import { DepositfixProvider } from '../providers/depositfix-provider';
import { Util } from '../config/utils';

declare const Stripe: any;

export class StripeMobilePayForm extends Form {

    protected stripeAPI: any;
    depositFixProvider: DepositfixProvider = new DepositfixProvider();
    provider: StripeProvider = new StripeProvider();
    protected view: StripeMobilePayView = new StripeMobilePayView();
    errorView: ErrorView = new ErrorView();
    type: FormTypes = {} as FormTypes;
    protected paymentType: PaymentType = {} as PaymentType;
    isNoTotal = false;
    protected ERROR_MESSAGE_COUNTRY_NOT_SUPPORTED = '';
    protected ERROR_MESSAGE_CREDIT_CARD_MISSING = '';
    paymentRequest: any;
    isPaymentRequestButtonEnabled = false;
    paymentMethodSubmitEvent: any;
    paymentMethodId = '';

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }

    async init(config: Config, callback: any) {
        await super.init(config, callback);
        return Promise.resolve();
    }

    render() {
        if (!this.isNoPayment) {
            this.stripeAPI = Stripe(this.config.forms.stripe.stripeKey);
        }

        if (this.step) {
            this.hideForm();
        }
        return Promise.resolve();
    }

    async createPaymentRequest() {
        this.view.renderForm();
        Util.getCountryCode().then((res: any) => {
            const country = res && res.country_code ? res.country_code : '';
            if (!this.provider.isPaymentRequestButtonCountrySupported(country)) {
                this.view.removeMobilePaymentMethodElement();
                this.logger.log(this.ERROR_MESSAGE_COUNTRY_NOT_SUPPORTED);
                return;
            }
            this.paymentRequest = this.stripeAPI.paymentRequest({
                country: country,
                currency: this.config.settings.currency.toLowerCase(),
                total: {
                    label: 'DepositFix',
                    amount: 0
                }
            });

            (async () => {
                const result = await this.paymentRequest.canMakePayment();
                if (this.shouldRenderPaymentRequestButton(result)) {
                    this.isPaymentRequestButtonEnabled = true;
                    this.addPaymentRequestButtonSubmitEvent();
                    this.addPaymentMethodSubmitEvent();
                    this.triggerEvent('amountChange');
                } else {
                    this.view.removeMobilePaymentMethodElement();
                    this.logger.log(this.ERROR_MESSAGE_CREDIT_CARD_MISSING);
                }
            })();

        });
    }

    protected shouldRenderPaymentRequestButton(result: any): boolean {
        return false;
    }

    addPaymentRequestButtonSubmitEvent() { }

    addPaymentMethodSubmitEvent() {
        this.paymentRequest.on('paymentmethod', async (event: any) => {
            const paymentMethod = event.paymentMethod;
            if (!paymentMethod) {
                event.complete('fail');
            }
            this.paymentMethodSubmitEvent = event;
            this.paymentMethodId = paymentMethod.id;
            await this.config.widget.submit();
        });
    }

    updatePaymentRequest(label: string, amount: number) {
        if (this.isPaymentRequestButtonEnabled) {
            this.paymentRequest.update({
                total: {
                    label: label,
                    amount: amount * 100
                }
            });
        }
    }

    closePaymentRequestModal() {
        if (this.isPaymentRequestButtonEnabled && this.paymentMethodSubmitEvent) {
            this.paymentMethodSubmitEvent.complete('success');
        }
    }

    async submit(order: Order) {
        const contact = order.params[0];
        order.paymentMethod = {
            type: this.paymentType,
            paymentMethodId: this.paymentMethodId,
            stripeEmail: contact.email,
            accountId: this.config.forms.stripe.accountId ? this.config.forms.stripe.accountId : null
        };
        return Promise.resolve(order);
    }

    postSubmit(submissionContext: any): Promise<any> {
        this.closePaymentRequestModal();
        this.config.widget.triggerAppEvent('onFormSubmitted', submissionContext);
        this.config.widget.redirectOrMessage();
        return Promise.resolve();
    }

    upSellSubmit(upsellResponse: any): Promise<any> {
        this.closePaymentRequestModal();
        this.config.widget.renderUpSell();
        return Promise.resolve();
    }

    hidePaymentFields() {
        this.view.hideForm();
    }

    showPaymentFields() {
        this.view.showForm();
    }

    showForm() {
        this.view.showForm();
    }

    hideForm() {
        this.view.hideForm();
    }

}
